import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {t} from "i18next";
import {MAX_Z_INDEX} from "@/Const";
import {createPortal} from "react-dom";

let mCallback:any;
const MessageTip = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowMessage : (szTips:string,callback:any)=>{
            setTipsInfo(szTips);
            mCallback = callback;

            setTimeout(()=>{
                setTipsInfo('');
            },5000)
        }
    }))

    const [tipsInfo,setTipsInfo] = useState('');

    /**
     * 高级---添加到body层...
     */
    return createPortal(
        <>
            {
                tipsInfo &&
                <div className={'flex-center'} style={{
                    position: 'fixed',
                    zIndex: MAX_Z_INDEX,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    top: '80px',
                    height: '36px',
                    borderRadius: '8px',
                    padding: '0 26px',
                    minWidth: '180px',
                    background:'var(--dialog-background-color)',
                    boxShadow: 'var(--dialog-box-shadow)'
                }}>
                    <span>{tipsInfo}</span>
                    <span style={{textDecoration: 'none', marginLeft: '22px'}} className={'link-color cursor-pointer'}
                          onClick={() => {
                              setTipsInfo('')
                              if (mCallback) {
                                  mCallback();
                              }
                          }}>{t("View")}</span>
                </div>
            }
        </>,document.body
    )
})
export default MessageTip;